import { identity } from 'ramda'

import { ReportType } from 'app/dataTypes/reports'
import { FinanceReportType } from 'app/dataTypes/reports/finances'

export const reportTypeFromApiString = (
  apiReportString: string,
  unknownReturn: (apiReportString: string) => string = identity,
): string /* TODO ReportType */ => {
  if (apiReportString === 'corrections') return ReportType.Corrections
  if (apiReportString === 'goverment_cafeteria_orders_by_classes') return ReportType.OrdersByClasses
  if (apiReportString === 'finances_summary') return ReportType.FinancesSummary
  if (apiReportString === 'finances_payments') return ReportType.FinancesSummaryReplenishment
  if (apiReportString === 'finances_write_offs') return ReportType.FinancesSummaryWriteOff
  if (apiReportString === 'average_check') return ReportType.AverageCheck
  // subsidies
  if (apiReportString === 'subsidies_grouped') return ReportType.SubsidiesGrouped
  if (apiReportString === 'subsidies_act') return ReportType.SubsidiesAct
  // Finance
  if (apiReportString === 'finances_e_money') return FinanceReportType.Emoney
  if (apiReportString === 'finances_e_money_legacy') return FinanceReportType.EmoneyLegacy
  if (apiReportString === 'encashment') return FinanceReportType.Encashments
  if (apiReportString === 'finances_by_sale_types') return FinanceReportType.BySellType
  if (apiReportString === 'cafeteria_cash') return FinanceReportType.CashBox
  if (apiReportString === 'finances_e_money_sales') return FinanceReportType.EmoneySales

  // TODO все отчеты
  return unknownReturn(apiReportString)
}
